import React from 'react';
import BaseModal from './table/BaseModal';
import { SecondaryButton, SubmitButton } from '@/components/ui/Button';

interface FormModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  onSubmit: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  isSaving?: boolean;
  submitDisabled?: boolean;
  hideSubmit?: boolean;
  hideFooter?: boolean;
  panelClassName?: string;
  children: React.ReactNode;
}

export default function FormModal({
  isOpen,
  onClose,
  title,
  description,
  onSubmit,
  submitLabel = 'Simpan',
  cancelLabel = 'Batal',
  isSaving = false,
  submitDisabled = false,
  hideSubmit = false,
  hideFooter = false,
  panelClassName = 'w-full max-w-3xl',
  children,
}: Readonly<FormModalProps>) {
  const footer = hideFooter ? undefined : (
    <>
      <SecondaryButton type="button" onClick={onClose} disabled={isSaving}>
        {cancelLabel}
      </SecondaryButton>
      {!hideSubmit && (
        <SubmitButton type="button" onClick={onSubmit} disabled={isSaving || submitDisabled}>
          {isSaving ? 'Menyimpan...' : submitLabel}
        </SubmitButton>
      )}
    </>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      description={description}
      panelClassName={panelClassName}
      footer={footer}
    >
      {children}
    </BaseModal>
  );
}
